import React from 'react'
import { useSelector } from 'react-redux'
import Avatar from '~/Common-Objects/Avatar/Avatar'
import DropdownMenu from '~/Common-Objects/UI/DropdownMenu'
import Icon from '~/Common-Objects/UI/Icon'
import Toggle from '~/Common-Objects/UI/Forms/Toggle/Toggle'
import axios from '~/data/http/axios'
import i18n from "~/i18n";
import { useDispatch } from "react-redux";
import * as userActions from '~/data/actions/userActions';
import { useHistory } from "react-router-dom";

export default function InboxLeftSidebarFooter({ inboxes = [], userRole = null, activeInbox = {} }) {
    const user = useSelector(state => state.user);
    const dispatch = useDispatch();
    const history = useHistory();
    const toggle = async () => {
        await axios.put('/accountUser', { chatOnline: !user.userData.chatOnline })
    }

    const showOnlineStatus = inboxes.some(inbox => {
        return inbox.InboxChannels.some(c => c.type === 2 && c.status === 'running')
    })

    let avatarClasses = "mar-r10 "
    if (showOnlineStatus) {
        avatarClasses += " avatarHolderStatus avatarHolderStatus-15 "
        if (user.userData.chatOnline) avatarClasses += "green"
        else avatarClasses += "grey"
    }

    const goLogout = () => {
        dispatch(userActions.logoutAndClear());
        window.open("/", "_self");
    }

    return (
        <div className="inbox-left-sidevar__footer">
            <DropdownMenu.Root>
                <DropdownMenu.Trigger
                    disabled={false}
                    variant="primary"
                    size="s"

                >
                    <div className="quickFlex">
                        <Avatar src={user.userData.profilePicFileName} className={avatarClasses} style={{ width: 15, height: 15 }} />
                        <div className="text-heavy text-sml">{user.userData.firstName} {user.userData.lastName}</div>
                    </div>
                </DropdownMenu.Trigger>
                <DropdownMenu.Portal>
                    <DropdownMenu.Content align="start">

                        <DropdownMenu.RadioGroup value={1} onClick={() => { history.push(`/cp/conversations/${activeInbox.id}/preferences`, { prevPath: location.pathname }) }}>
                            <DropdownMenu.RadioItem value="unassigned" >
                                {i18n.t("chat:userPreferences.yourPreferences")}
                            </DropdownMenu.RadioItem>
                        </DropdownMenu.RadioGroup>
                        {/* <DropdownMenu.Separator />
                        <DropdownMenu.RadioGroup value={1} onClick={goLogout}>
                            <DropdownMenu.RadioItem value="unassigned" >
                                <Icon name="logout" color="#9B9FA6" /> Logout
                            </DropdownMenu.RadioItem>
                        </DropdownMenu.RadioGroup> */}

                    </DropdownMenu.Content>
                </DropdownMenu.Portal>
            </DropdownMenu.Root >

            {showOnlineStatus && userRole < 2 && <Toggle before={user.userData.chatOnline ? i18n.t("chat.inbox.leftBar.available") : i18n.t("chat.inbox.leftBar.away")} checked={user.userData.chatOnline} onChange={toggle} />}
        </div >
    )
}